/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { TournamentTeamResponse } from './TournamentTeamResponse';
import {
    TournamentTeamResponseFromJSON,
    TournamentTeamResponseFromJSONTyped,
    TournamentTeamResponseToJSON,
    TournamentTeamResponseToJSONTyped,
} from './TournamentTeamResponse';

/**
 * 
 * @export
 * @interface TournamentWaitlistJoinResponse
 */
export interface TournamentWaitlistJoinResponse {
    /**
     * 
     * @type {TournamentTeamResponse}
     * @memberof TournamentWaitlistJoinResponse
     */
    team: TournamentTeamResponse;
    /**
     * 
     * @type {number}
     * @memberof TournamentWaitlistJoinResponse
     */
    position: number;
    /**
     * 
     * @type {string}
     * @memberof TournamentWaitlistJoinResponse
     */
    message: string;
}

/**
 * Check if a given object implements the TournamentWaitlistJoinResponse interface.
 */
export function instanceOfTournamentWaitlistJoinResponse(value: object): value is TournamentWaitlistJoinResponse {
    if (!('team' in value) || value['team'] === undefined) return false;
    if (!('position' in value) || value['position'] === undefined) return false;
    if (!('message' in value) || value['message'] === undefined) return false;
    return true;
}

export function TournamentWaitlistJoinResponseFromJSON(json: any): TournamentWaitlistJoinResponse {
    return TournamentWaitlistJoinResponseFromJSONTyped(json, false);
}

export function TournamentWaitlistJoinResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): TournamentWaitlistJoinResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'team': TournamentTeamResponseFromJSON(json['team']),
        'position': json['position'],
        'message': json['message'],
    };
}

export function TournamentWaitlistJoinResponseToJSON(json: any): TournamentWaitlistJoinResponse {
    return TournamentWaitlistJoinResponseToJSONTyped(json, false);
}

export function TournamentWaitlistJoinResponseToJSONTyped(value?: TournamentWaitlistJoinResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'team': TournamentTeamResponseToJSON(value['team']),
        'position': value['position'],
        'message': value['message'],
    };
}

